module.exports = __webpack_public_path__ + "img/logo.baee85bd.png";